<template>
  <div
      class="ui-input"
      :tabindex="activeTabindex"
      @click="handlerClick"
      @mousedown="onMouseDown"
      @focusout="blur"
      @focus="focus"
  >
    <ui-input-container
        class="ui-input__hood"
        :class="containerClass"
        :title="title"
        :has-description="hasDescription"
        :has-value="hasValue"
        :has-title="hasTitle"
        :has-filled-highlight="hasFilledHighlight"
        :small="small"
        :focus="isFocus"
        :error="error"
        :error-text="errorText"
        :skeleton-loading="skeletonLoading"
    >
      <input
        class="ui-input__input"
        ref="input"
        :value="innerValue"
        :type="type"
        :placeholder="innerPlaceholder"
        :disabled="disabled"
        :maxlength="maxLength"
        :inputmode="inputMode"
        tabindex="-1"
        v-mask="mask"
        @input="onInput"
        @focus="focus"
        @keyup.enter="submit"
      />
      <template #after>
        <div class="ui-input__icon-list">
          <ui-loading
              class="ui-input__icon-list--icon"
              v-if="hasLoading"
              size="small"
              hide-transition
          />
          <ui-icon
              v-if="showClearIcon"
              class="ui-input__icon-list--icon hover-icon clear-icon"
              name="roundClose"
              @click="clearValue"
          />
          <ui-copy-button
            class="ui-input__icon-list--icon"
            v-if="copy"
            :text="innerValue"
            @copy="onCopyButtonClick"
          />
          <ui-icon
              class="ui-input__icon-list--icon"
              v-if="customIcon"
              v-bind="customIcon"
          />
        </div>
        <slot name="after"></slot>
      </template>
      <template #description>
        <slot />
      </template>
    </ui-input-container>
    <ui-autocomplete
      class="ui-input__autocomplete"
      v-if="autocomplete"
      v-model="innerValue"
      :is-open="isShowAutocomplete"
      :container="$el"
      :entity-name="autocompleteEntityName"
      :search-field-name="autocompleteSearchFieldName"
      :embed="autocompleteEmbed"
      :list="autocompleteList"
      :min-search-field-size="autocompleteMinSearchFieldSize"
      :max-search-field-size="autocompleteMaxSearchFieldSize"
      :is-search-api="autocompleteIsSearchApi"
      @change="selectAutocomplete"
      @loading-start="setAutocompleteLoadingState(true)"
      @loading-end="setAutocompleteLoadingState(false)"
    >
      <template #item="{item}">
        <slot name="autocompleteItem" :item="item" />
      </template>
    </ui-autocomplete>
  </div>
</template>

<script>
import UiInputContainer from './UiInputContainer.vue'
import UiIcon from '../icons/UiIcon.vue'
import UiLoading from '../loader/UiLoading.vue'
import UiAutocomplete from '../UiAutocomplete.vue'
import UiCopyButton from '../UiCopyButton.vue'

import inputElementMixin from '../../mixins/inputElementMixin'

export default {
  components: {
    UiInputContainer,
    UiIcon,
    UiLoading,
    UiAutocomplete,
    UiCopyButton
  },
  mixins: [inputElementMixin],
  props: {
    mask: [String, Object]
  },
  computed: {
    innerPlaceholder () {
      if (this.small) return this.placeholder ?? this.title
      return this.placeholder
    }
  }
}

</script>

<style lang="scss" scoped>
.ui-input {
  position: relative;

  ::v-deep() &__hood {
    .ui-input-container {
      height: 54px;
      cursor: text;
    }

    &.small .ui-input-container {
      height: 40px;
    }

    &.disabled .ui-input-container {
      background: $gray-7;
      color: $gray-3;
      cursor: auto;
    }
  }

  &__autocomplete {
    position: absolute;
    min-width: 100%;
    width: max-content;
    z-index: 2;

    @include media-max-sm {
      //Перекрываем инлайновое вычисление ширины
      width: 100% !important;
    }
  }

  &__icon-list {
    display: flex;
    align-items: center;

    &--icon {
      margin-left: 10px;
      fill: $gray-02;

      &._hover {
        cursor: pointer;
      }

      &.hover-icon {
        fill: $gray-05;
        transition: fill .1s;
        cursor: pointer;

        &:hover {
          fill: $gray-02;
        }
      }
    }
  }

  &__input {
    @include ellipsis;
    @include hiddenInputArrow;
    display: flex;
    flex: 1;
    width: 20px;
    height: 20px;
    padding: 0;
    background: inherit;
    border: initial;

    &::placeholder {
      color: $gray-06 !important;
    }

    &:disabled {
      color: $gray-3 !important;
      background: inherit;
    }
  }
}
</style>
